import styled from "styled-components";

export const StyledLyrics = styled.p`
  font-family: "Poppins";
  font-weight: 800;
  font-size: 20px;

  @media screen and (max-width: 750px) {
    font-size: 0.75em;
  }
`;

export const StyledPlayerDiv = styled.div`
  @media screen and (max-width: 750px) {
    margin-bottom: 4rem;
  }
`;
